import { render } from "./DatasetPreviewTable.vue?vue&type=template&id=4642a5a2&ts=true"
import script from "./DatasetPreviewTable.vue?vue&type=script&lang=ts"
export * from "./DatasetPreviewTable.vue?vue&type=script&lang=ts"

import "./DatasetPreviewTable.vue?vue&type=style&index=0&id=4642a5a2&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__